import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClientAuthShell } from "./ClientShell";
import { capi } from "./clientApi";

export default function ClientForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    // Réponse générique constante, quelle que soit l'existence du compte.
    await capi("/auth/forgot-password", { method: "POST", body: { email } }).catch(() => {});
    setSent(true);
    setBusy(false);
  };

  return (
    <ClientAuthShell>
      <form className="cp-card" onSubmit={submit} data-testid="cp-forgot-form">
        <h1 className="cp-title">Mot de passe oublié</h1>
        <p className="cp-sub">Indiquez votre e-mail : si un compte existe, SLIZ vous recontacte.</p>
        {sent ? (
          <p className="cp-ok" data-testid="cp-forgot-ok">
            Si ce compte existe, SLIZ vous recontacte rapidement.
          </p>
        ) : (
          <div className="cp-field">
            <label htmlFor="cp-fe">E-mail</label>
            <input id="cp-fe" className="cp-input" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="cp-forgot-email" autoComplete="email" />
          </div>
        )}
        {!sent && (
          <button className="cp-btn cp-btn-primary" type="submit" disabled={busy}
            data-testid="cp-forgot-submit">
            {busy ? "Envoi…" : "Envoyer la demande"}
          </button>
        )}
        <div className="cp-links">
          <button type="button" className="cp-link"
            onClick={() => navigate("/espace-client/connexion")}
            data-testid="cp-forgot-back">Retour à la connexion</button>
        </div>
      </form>
    </ClientAuthShell>
  );
}
